import { SubjectRoles } from "@/api-schema-enums";
import { AttributeAppRolePrefix, extractAttributeAppRolesByPrefix } from "@/common/helpers/user-attribute-app-roles";
import { userStore } from "@/store/user-store";
import { useMemo } from "react";

const EMPTY_ROLES: string[] = [];

export function useTransportCompanyAssignment() {
  const roles = userStore((state) => state.user?.roles ?? EMPTY_ROLES);
  const isExternalUser = roles.includes(SubjectRoles.Ext);

  const assignedTransportCompanyRoles = useMemo(
    () => extractAttributeAppRolesByPrefix(roles, AttributeAppRolePrefix.Company),
    [roles],
  );

  const hasTransportCompanyAssignment = assignedTransportCompanyRoles.length > 0;

  return {
    assignedTransportCompanyRoles,
    hasTransportCompanyAssignment,
    isExternalUser,
    shouldShowFallback: isExternalUser && !hasTransportCompanyAssignment,
  };
}
